import {Component, OnInit, ViewChild} from '@angular/core';

import {IUserDetail} from "../../models/user-detail.model";
import {CurrentUserService} from "../../services/current-user.service";
import {ActivatedRoute, Router} from '@angular/router';
import {ROUTES} from '../../routes';
import {ToastrService} from 'ngx-toastr';
import {MembersService} from "../../services/members.service";
import {MemberLogic} from "../../models/member-logic";
import moment from "moment";
import {
    GenericModalComponent,
    GenericModalConfig
} from "../../shared/generic-modal-component/generic-modal-component.component";
import {TextInputModalComponent} from "../../shared/text-input-modal/text-input-modal.component";
import {EmailValidationTypes} from "../../../../Constants/EmailValidationTypes";

@Component({
        selector: 'eil-account-detail',
        templateUrl: './account-detail.component.html',
        styleUrls: ['./account-detail.component.scss'],
        standalone: false
    }
)
export class AccountDetailComponent implements OnInit {

    @ViewChild(GenericModalComponent) genericModal: GenericModalComponent;
    @ViewChild(TextInputModalComponent) textInputModal: TextInputModalComponent;


    // @Input() public inputExample:    string;

    // public publicExample:            string;
    // public anotherExample:           any;

    // private privateExample:          boolean;

    currentUser: IUserDetail = {};
    user: IUserDetail = {};
    waiting: boolean;
    memberLogic = new MemberLogic();
    emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    postalCodeRegex = /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i;
    phoneNumberRegex = /^1?[ -]?\(?[0-9]{3}\)?[ -]?[0-9]{3}[ -]?[0-9]{4}$/;

    creditsToAdd: number;

    constructor(private currentUserService: CurrentUserService,
                private membersService: MembersService,
                private toastrService: ToastrService,
                protected router: Router,
                private route: ActivatedRoute) {

    }

    ngOnInit() {

        // check if we're editing the current user or someone else (whether there's an ID parameter in the route)
        const paramMap = this.route.snapshot.paramMap;
        if (paramMap.has('id')) {

            // subscribe but only for the current user
            this.currentUserService.currentUser.subscribe(user => {
                this.currentUser = user;

                if (!user.isLoaded || !user.isAuthenticated) {
                    // redirect to login (with a return path) so that the user can be authorized and then come back to this
                    this.router.navigate([ROUTES.LOGIN], {queryParams: {returnUrl: this.router.url}});

                }
            });

            const id = paramMap.get('id');
            if (id) {
                // flag wait
                this.waiting = true;
                this.membersService.getOne(id,
                    (success, result) => {
                        if (success) {

                            this.user = result;

                            // unflag wait
                            this.waiting = false;
                        }
                    });
            } else {
                // TODO: throw an error?
            }
        } else {
            // subscribe as both (force refresh though)
            this.currentUserService.load(() => {
            });
            this.currentUserService.currentUser.subscribe(user => {
                this.currentUser = user;
                this.user = user;

                if (!user.isLoaded || !user.isAuthenticated) {
                    // redirect to login (with a return path) so that the user can be authorized and then come back to this
                    this.router.navigate([ROUTES.LOGIN], {queryParams: {returnUrl: this.router.url}});

                }
            });
        }
    }


    showEmailChangeModal(member: any) {
        this.textInputModal.show({
            title: 'Change Email Address',
            placeholder: 'Enter new email address',
            confirmText: 'Change Email',
            cancelText: 'Cancel',
            required: true,
            inputType: 'email',
            validationErrors: [],
            showValidationErrors: false,
            onConfirm: (newEmail: string) => {
                this.handleEmailChange(member, newEmail);
            }
        });
    }

    showAdminPanel() {
        return this.currentUser && this.currentUser.email
            && this.currentUser.isAdmin
            && this.user && this.user.email
            && this.user.email !== this.currentUser.email;
    }

    onSave() {
        this.waiting = true;
        this.currentUserService.save(this.user,
            (success, result, error) => {
                this.waiting = false;
                if (success && result) {
                    this.toastrService.success("Information saved.");
                    if (this.currentUser.isAdmin) {
                        this.router.navigateByUrl(`${ROUTES.ADMIN}/${ROUTES.ADMIN_MEMBERS}`);
                    } else {
                        this.router.navigateByUrl(ROUTES.HOME);
                    }
                } else if (!error.displayHasBeenHandled) {
                    this.toastrService.error(error.errorMessage);
                }
            });
    }

    toggleMemberSetting(member: IUserDetail, valueToSet: boolean, settingName: string) {

        if (confirm(`Change ${settingName} for ${member.firstName} ${member.lastName} to ${valueToSet}?`)) {
            this.waiting = true;
            this.membersService.setMemberSetting(member.email, settingName, valueToSet,
                (success, result, error) => {
                    if (success) {
                        this.user = result;
                        this.toastrService.success("Setting changed.");
                    } else if (!error.displayHasBeenHandled) {
                        this.toastrService.error(error.errorMessage);
                    }
                    // unflag wait
                    this.waiting = false;
                });
        }
    }

    reject(member: IUserDetail) {
        if (confirm(`This will reject ${member.firstName} ${member.lastName}.  Are you sure?`)) {
            this.waiting = true;
            this.membersService.reject(member.email,
                (success, error) => {
                    if (success) {
                        this.toastrService.success("Member rejected.");
                        this.router.navigateByUrl(`${ROUTES.ADMIN}/${ROUTES.ADMIN_MEMBERS}`);
                    } else if (!error.displayHasBeenHandled) {
                        this.toastrService.error(error.errorMessage);
                    }
                    // unflag wait
                    this.waiting = false;
                });
        }
    }

    deactivate(member: IUserDetail) {
        // TODO: something clearer
        this.toggleMemberSetting(member, false, "IsApproved");
    }

    reactivate(member: IUserDetail) {
        // TODO: something clearer
        this.toggleMemberSetting(member, true, "IsApproved");
    }

    toggleIsRegistered(member: IUserDetail, valueToSet: boolean) {
        this.toggleMemberSetting(member, valueToSet, "IsRegistered");
    }

    toggleIsApproved(member: IUserDetail, valueToSet: boolean) {
        this.toggleMemberSetting(member, valueToSet, "IsApproved");
    }

    toggleIsMember(member: IUserDetail, valueToSet: boolean) {
        this.toggleMemberSetting(member, valueToSet, "IsMember");
    }

    toggleIsAdmin(member: IUserDetail, valueToSet: boolean) {
        this.toggleMemberSetting(member, valueToSet, "IsAdmin");
    }

    addCredits(amount) {
        if (confirm(`Add ${amount} to this member's credits?`)) {
            this.waiting = true;
            this.membersService.addCredits(this.user.email,
                amount,
                (success, result, error) => {
                    if (success) {
                        this.toastrService.success("Credits added.");
                        this.user = result;
                    } else if (!error.displayHasBeenHandled) {
                        this.toastrService.error(error.errorMessage);
                    }
                    // unflag wait
                    this.waiting = false;
                });
        }
    }

    unsubscribe() {
        if (confirm(`Are you sure you want to unsubscribe from all EIL mail?`)) {
            this.waiting = true;
            this.membersService.unsubscribe(this.user.email,
                (success, result, error) => {
                    if (success) {
                        this.toastrService.success("Unsubscribed.");
                        this.user = result;
                    } else if (!error.displayHasBeenHandled) {
                        this.toastrService.error(error.errorMessage);
                    }
                    // unflag wait
                    this.waiting = false;
                });
        }
    }

    resubscribe() {
        if (confirm(`Are you sure you want to resubscribe to EIL mail?`)) {
            this.waiting = true;
            this.membersService.resubscribe(this.user.email,
                (success, result, error) => {
                    if (success) {
                        this.toastrService.warning("Subscribed.  NOTE: if you have previously unsubscribed, you may receive an email requiring that you confirm your resubscription before it takes effect.");
                        this.user = result;
                    } else if (!error.displayHasBeenHandled) {
                        this.toastrService.error(error.errorMessage);
                    }
                    // unflag wait
                    this.waiting = false;
                });
        }
    }

    getDisplayDate(date) {
        return moment(date).format("YYYY-MM-DD");
    }

    private handleEmailChange(member: any, newEmail: string) {
        if (!newEmail) {
            this.textInputModal.updateValidationErrors(["The new email can not be empty."]);
            return;
        } else if (newEmail === member.email) {
            this.textInputModal.updateValidationErrors(["The new email can not be the same as the current email."]);
            return;
        }

        this.membersService.validateEmailChange(member.email, newEmail,
            (success, validationResult, error) => {

                // Front end validation
                if (!success) {
                    validationResult.error ? this.textInputModal.updateValidationErrors([validationResult.error]) :
                        this.textInputModal.updateValidationErrors(['Validation failed. Please try again.']);
                    return;
                }

                if (validationResult.validationType === EmailValidationTypes.InvalidEmail) {
                    this.textInputModal.updateValidationErrors(["Please enter a valid email address."]);
                    return;
                } else if (validationResult.validationType === EmailValidationTypes.Deactivated) {
                    this.textInputModal.hide();
                    this.showDeactivatedAccountModal(validationResult.email);
                    return;

                } else if (validationResult.validationType === EmailValidationTypes.Pending) {
                    this.textInputModal.hide();
                    this.showPendingAccountModal(validationResult.email);
                    return;
                } else if (validationResult.validationType === EmailValidationTypes.Active) {
                    this.textInputModal.hide();
                    this.showActiveAccountModal(validationResult.firstName, validationResult.lastName);
                    return;
                }

                if (validationResult.canProceed) {
                    this.textInputModal.hide();
                    this.proceedWithEmailChange(member, newEmail);
                    return;
                }

                // Handle other validation types
                this.textInputModal.hide();
                this.toastrService.error('Email change not allowed - unrecognized validation result. Please contact support.');
            });
    }

    private showDeactivatedAccountModal(email: string): void {
        const config: GenericModalConfig = {
            title: 'Deactivated Account Exists',
            content: `There exists a deactivated account with the requested email address: ${email}. It is not possible to change the email address of the selected account as requested. Please either reactivate the deactivated account or ask the user to use the existing account instead.`,
            confirmText: 'OK',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-primary',
        };
        this.genericModal.show(config);
    }

    private showPendingAccountModal(email: string): void {
        const config: GenericModalConfig = {
            title: 'Pending Account Exists',
            content: `There exists a pending account with the requested email address: ${email}. NOTE: If that pending account is approved, you will NOT be able to use that email address on this account. You could reject the pending account and try changing the email here again.`,
            confirmText: 'OK',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-primary'
        };
        this.genericModal.show(config);
    }

    private showActiveAccountModal(firstName: string, lastName: string): void {
        const config: GenericModalConfig = {
            title: 'Cannot Change Email',
            content: `An active account already exists with the requested email.\n\nFirst Name: ${firstName}\nLast Name: ${lastName}\n\nIt is not possible to change the email address of the selected account as requested.`,
            confirmText: 'OK',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-primary'
        };
        this.genericModal.show(config);
    }

    private showReminderToSignUpModal(): void {
        const config: GenericModalConfig = {
            title: 'Reminder',
            content: `Before the user with the requested email can use this account, they must first <b>sign up</b> for an account using the new email address`,
            confirmText: 'OK',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-primary'
        };
        this.genericModal.show(config);
    }

    private proceedWithEmailChange(member: IUserDetail, newEmail: string) {
        this.showReminderToSignUpModal();
        this.membersService.changeEmail(member.email, newEmail,
            (success, error) => {
                if (success) {
                    this.toastrService.success("Email changed.");
                    // Reinitialize the component to refresh data
                    this.ngOnInit();

                } else if (!error.displayHasBeenHandled) {
                    this.toastrService.error(error.errorMessage);
                }
                this.waiting = false;
            });
    }
}
